/**
 * 公共接口.
 */

import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export interface UploadImageResponse {
  imageUrl: string;
  ratio: number;
}

/**
 * 上传图片.
 *
 * @param file 图片文件.
 * @returns 图片信息.
 */
export const uploadImage = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const resp = await axiosInstance.post<BaseResponse<UploadImageResponse>>(
    `${baseUrl}/common/uploadImage`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return resp.data;
};

/**
 * 获取通用选项（包含 appleSubscribeVIPLevels 等）
 * @returns 通用选项数据
 */
export const getCommonOptions = async () => {
  const resp = await axiosInstance.get<BaseResponse<{
    appleSubscribeVIPLevels?: { value: number; text: string }[];
    [key: string]: any;
  }>>(`${baseUrl}/common/options`);
  return resp.data;
};
